import invariant from 'react-utils/invariant';
import { AssignmentPanelInstances, DEFAULT_PANEL_ID } from './panels/AssignmentPanel';
export default {
  openAssignmentPanel({
    objectId,
    objectType,
    ownerId,
    panelId = DEFAULT_PANEL_ID
  }) {
    if (!AssignmentPanelInstances[panelId]) {
      invariant(AssignmentPanelInstances[panelId], '<AssignmentPanel /> was either not rendered before calling `openAssignmentPanel` or an unknown panelId was passed');
      return;
    }

    // @ts-expect-error Calling a react component's method from outside
    AssignmentPanelInstances[panelId].open({
      objectId,
      objectType,
      ownerId
    });
  }
};